import { Skeleton, styled, Switch, Tooltip } from '@mui/material';
import Box from '@mui/material/Box';
import React from 'react';
import { HomeDashData, homeStyles } from '..';

export function TicketTotals(props: {
  data: HomeDashData | null | undefined;
  loading: boolean;
}) {
  // Props
  const { data, loading } = props;
  // State
  const [toggle, setToggle] = React.useState(false);

  const CustomSwitch = styled(Switch)({
    '.MuiSwitch-thumb': {
      backgroundColor: '#fff',
    },
    '.MuiSwitch-track': {
      backgroundColor: '#000000',
    },
    '& .MuiSwitch-switchBase': {
      '&.Mui-checked': {
        '+ .MuiSwitch-track': {
          backgroundColor: '#000000',
        },
        '.MuiSwitch-thumb': {
          backgroundColor: '#fff',
        },
      },
    },
  });

  const noTix =
    (!toggle && data?.HierarchyTixTotal === 0) ||
    (toggle && data?.BaseshopTixTotal === 0);

  return (
    <Box
      flex={1}
      p={1}
      sx={{
        ...homeStyles.box,
        minHeight: 120,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          textTransform: 'uppercase',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {data?.UpcomingConvention || 'Next Event'}
      </Box>
      {loading ? (
        <Skeleton variant="rectangular" height={55} />
      ) : (
        <Box
          px={1}
          sx={{
            fontSize: 36,
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Box
            flex={1}
            style={{
              color: noTix ? 'red' : '#fff',
              fontWeight: noTix ? 'bold' : 'normal',
            }}
          >
            {!toggle ? data?.HierarchyTixTotal : data?.BaseshopTixTotal}
          </Box>
        </Box>
      )}

      <Box
        sx={{
          textTransform: 'uppercase',
          fontSize: 14,
          fontFamily: 'Lato',
          fontWeight: 300,
          letterSpacing: 2,
        }}
      >
        {!toggle ? ` Hierarchy Tickets` : `Baseshop Tickets`}
      </Box>
      <Tooltip
        title={
          !toggle ? 'Switch to Baseshop Tickets' : 'Switch to Hierarchy Tickets'
        }
        arrow
        slotProps={{
          tooltip: { sx: { backgroundColor: '#17191B', p: 1 } },
          arrow: { sx: { color: '#17191B' } },
        }}
      >
        <CustomSwitch
          size="small"
          value={toggle}
          checked={toggle}
          onChange={() => setToggle(!toggle)}
          sx={{
            position: 'absolute',
            right: 10,
            top: '50%',
            bottom: '50%',
            margin: 'auto',
          }}
        />
      </Tooltip>
    </Box>
  );
}
